module.exports = __webpack_public_path__ + "img/xiaomi.6aaee7de.png";